/**
 * @author Andrés Ferreira
 * @Copyright (c) Infotrack. All rights reserved.
 */
import { IRespuesta } from '@infotrack/presentacion-transversales/interfacesComunes';
import manejadorRest from '@infotrack/presentacion-utilitarios/manejadorRest';
import { negocio } from '../../conexiones';
import IFabricantes from './entidades/fabricantes';
import IFiltrosFabricantes from './entidades/filtrosFabricantes';

export default class ModeloFabricantes {
    public consultarFabricantes() {
        return manejadorRest<IRespuesta<IFabricantes>>(() => negocio.get('Fabricantes/ConsultarListaFabricantes'));
    }
    public crearFabricantes(fabricantes: IFabricantes) {
        return manejadorRest<IRespuesta<IFabricantes>>(() =>
            negocio.post('Fabricantes/GuardarFabricantes', fabricantes)
        );
    }
    public editarFabricantes(fabricantes: IFabricantes) {
        return manejadorRest<IRespuesta<IFabricantes>>(() => negocio.put('Fabricantes/EditarFabricantes', fabricantes));
    }
    public eliminarFabricantes(fabricantes: IFabricantes) {
        return manejadorRest<IRespuesta<IFabricantes>>(() =>
            negocio.delete('Fabricantes/EliminarFabricantes', fabricantes)
        );
    }
    public consultarListaFabricantesPorFiltro(filtrosFabricantes: IFiltrosFabricantes) {
        return manejadorRest<IRespuesta<IFabricantes>>(
            () => negocio.post('Fabricantes/consultarListaFabricantesPorFiltro', filtrosFabricantes),
            true
        );
    }
}
